import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";
import { PLAYER_PANEL } from "@/constants/testIds";

const LINKS = [
  { to: "/ucet", label: "Můj účet", icon: "fa-dragon", testId: PLAYER_PANEL.accountLink },
  { to: "/ekonomika", label: "Horowitzova banka", icon: "fa-landmark", testId: PLAYER_PANEL.bankLink },
];

// Left-hand navigation shown across the whole account/economy area
// ("adminka"), for any logged-in player.
export const PlayerPanel = () => {
  const { logout } = useAuth();
  const location = useLocation();

  return (
    <nav
      data-testid={PLAYER_PANEL.nav}
      className="h-fit rounded-xl border border-white/10 bg-[#17171b] p-5 lg:sticky lg:top-28"
    >
      <p className="mb-4 font-display text-xs font-600 uppercase tracking-[0.3em] text-[#F0801F]">
        Hráčský panel
      </p>
      <ul className="space-y-1">
        {LINKS.map((link) => {
          const active = location.pathname === link.to;
          return (
            <li key={link.to}>
              <Link
                to={link.to}
                data-testid={link.testId}
                className={`flex items-center gap-2.5 rounded-md px-3 py-2.5 text-sm transition-colors ${
                  active
                    ? "bg-[#F0801F]/15 text-[#F0801F]"
                    : "text-white/70 hover:bg-white/[0.06] hover:text-white"
                }`}
              >
                <i className={`fa-solid ${link.icon} text-xs`} />
                {link.label}
              </Link>
            </li>
          );
        })}
      </ul>
      <button
        onClick={logout}
        data-testid={PLAYER_PANEL.logoutButton}
        className="mt-4 flex w-full items-center gap-2.5 rounded-md border-t border-white/10 px-3 pt-4 text-sm text-white/50 transition-colors hover:text-[#F0801F]"
      >
        <i className="fa-solid fa-right-from-bracket text-xs" />
        Odhlásit
      </button>
    </nav>
  );
};
